import { config } from 'config';
import { sendMultiPartRequest, sendRequest } from 'services/base/sendRequest';
import { appConfig } from '../../config/app';
import { parseFetchError } from 'utils/http';

const sendReport = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.ethicalInbox.prefix +
    appConfig.api_routes.modules.ethicalInbox.services.report;

  let formData = new FormData();
  formData.forEach(entry => {
    console.log(entry.toString());
  });
  formData.append('type', data.type);
  if (data.locatedCity.code !== '-1') {
    formData.append('locatedCity', JSON.stringify(data.locatedCity));
  }
  formData.append('whereItHappened', data.whereItHappened);
  formData.append('companyArea', data.companyArea);
  formData.append('details', data.details);

  if (data.issue.code !== '-1') {
    formData.append('issue', JSON.stringify(data.issue));
  }
  formData.append('anonymous', data.anonymous);
  formData.append('name', data.name);
  formData.append('email', data.email);

  if (data.counterpartType.code !== '-1') {
    formData.append('counterpartType', JSON.stringify(data.counterpartType));
  }
  if (data.howDidYouKnow.code !== '-1') {
    formData.append('howDidYouKnow', JSON.stringify(data.howDidYouKnow));
  }
  if (data.residenceCity.code !== '-1') {
    formData.append('residenceCity', JSON.stringify(data.residenceCity));
  }
  formData.append(
    'privacyPolicyAuthorization',
    JSON.stringify(data.privacyPolicyAuthorization),
  );
  formData.append(
    'notificationAuthorization',
    JSON.stringify(data.notificationAuthorization),
  );

  if (data.providedEvidenceList) {
    let docNames = '';
    let len = 0;
    data.providedEvidenceList.forEach((doc, index) => {
      docNames += doc.name + ',';
      formData.append('document', doc.file);
      len++;
    });
    console.log('docNames: ' + docNames);
    formData.append(
      'evidenceDocNames',
      docNames.substring(0, docNames.length - 1),
    );
    formData.append('evidenceListSize', '' + len);
  }

  return sendMultiPartRequest(serviceUrl, formData);
};

const sendResponse = data => {
  const serviceUrl =
    config.serverURL +
    appConfig.api_routes.prefix +
    appConfig.api_routes.modules.ethicalInbox.prefix +
    appConfig.api_routes.modules.ethicalInbox.services.response;

  return sendRequest(serviceUrl, { id: data.id, details: data.details }, true);
};

const edit = (id: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      const serviceUrl =
        config.serverURL +
        appConfig.api_routes.prefix +
        appConfig.api_routes.modules.ethicalInbox.prefix +
        appConfig.api_routes.modules.ethicalInbox.services.view;
      const res = await fetch(serviceUrl, {
        headers: {
          'Access-Control-Allow-Origin': config.serverDomain,
          'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ id }),
      });
      const dataOut = await res.json();
      resolve(dataOut);
    } catch (e) {
      reject({
        respCode: -1,
        message: parseFetchError(e),
      });
    }
  });
};

export { sendReport, sendResponse, edit };
